module.exports = "<div class=\"container\" [innerHTML]=\"'login_imprint_text' | translate\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main.component.html
// module id = ./src/app/main.component.html
// module chunks = main